import { createContext } from "react";

export const TooltipAttachedContext = createContext(false);
